import { schema } from 'normalizr';

export const roleSchema = new schema.Entity('role');
